import Honeybadger from "@honeybadger-io/js"

const apiKey = document.querySelector("meta[name='honeybadger-api-key']")?.content
const environment = document.querySelector("meta[name='environment']")?.content || "test"
const revision = document.querySelector("meta[name='revision']")?.content || "main"
const debug = false
const isSignedIn = () => document.querySelector("meta[name='signed-in']")?.content || "unknown"
const currentUserId = () => document.querySelector("meta[name='current-user-id']")?.content

// https://docs.honeybadger.io/lib/javascript/guides/using-source-maps/#improving-error-grouping-and-linking-to-source-code
//
// Looks like everything starts with `webpack://dockspot/.`, e.g. Stimulus says:
// webpack://dockspot/./node_modules/@hotwired/stimulus/dist/stimulus.js:1668:16:in `connect'
const projectRoot = "webpack://dockspot/./"

Honeybadger.configure({
  debug,
  apiKey,
  environment,
  revision,
  projectRoot,
  breadcrumbsEnabled: true,
  maxErrors: 20,
  ignoreBrowserExtensionErrors: true,
})

Honeybadger.beforeNotify(function (notice) {
  // Drop errors we can't attribute to any source: the raw stack has lines, but
  // none of them parse to a source file. This implies they are
  // eval:ed or injected from outside our app, or belong to a browser
  // extension.
  if (notice.stack && (notice.backtrace || []).length === 0) { return false }

  // plugins / extensions
  if (/__gCrWeb/.test(notice.message)) { return false }
  if (/safari-extension/.test(notice.message)) { return false }
  if (/webkitExitFullScreen/.test(notice.message)) { return false }
  if (/a\[b\]\.target\.className\.indexOf\(Zb\)/.test(notice.message)) { return false }
  if (/window\.webkit\.messageHandlers/.test(notice.message)) { return false }
  if (/undefined is not an object \(evaluating 'a\.L'\)/.test(notice.message)) { return false }
  if (/_AutofillCallbackHandler/.test(notice.message)) { return false }
  if (/Can't find variable: gmo/.test(notice.message)) { return false }
  // Safari masks the URLs of browser-extension scripts in Error.stack as
  // "webkit-masked-url://hidden/" - a privacy measure so sites can't fingerprint
  // which extensions a user has installed. Extension code, not our bundle. The
  // masked URL shows up in the message or the stack depending on how it throws.
  // See https://trackjs.com/javascript-errors/webkit-masked-url-hidden/
  if (/webkit-masked-url/.test(notice.message) || /webkit-masked-url/.test(notice.stack)) { return false }

  // Twilio
  if (/UnhandledPromiseRejectionWarning: disconnected/.test(notice.message)) { return false }
  if (/UnhandledPromiseRejectionWarning: n: disconnected/.test(notice.message)) { return false }
  if (/UnhandledPromiseRejectionWarning: Error: disconnected/.test(notice.message)) { return false }
  if (/Twilsock: request timeout/.test(notice.message)) { return false }

  // ResizeObserver benign loop warning (browsers fire this with no real error).
  if (/ResizeObserver loop/.test(notice.message)) { return false }

  // Network errors
  if (/AbortError: Fetch is aborted/.test(notice.message)) { return false }
  if (/AbortError: The user aborted a request/.test(notice.message)) { return false }
  if (/AbortError: The operation was aborted/.test(notice.message)) { return false }
  if (/TypeError: NetworkError when attempting to fetch resource/.test(notice.message)) { return false }
  if (/TypeError: Failed to fetch/.test(notice.message)) { return false }
  if (/TypeError: Load failed/.test(notice.message)) { return false } // Safari's wording for an aborted/failed fetch
  if (/AjaxNetworkError/.test(notice.name)) { return false }
  if (/AjaxUnauthorizedResponseError/.test(notice.name)) { return false }
  if (/UnhandledPromiseRejectionWarning:\sObject\sNot\sFound\sMatching\sId:/.test(notice.message)) { return false }
  // Unhandled rejections without message / stack -> not actionable, most likely aborted request
  if (/^UnhandledPromiseRejectionWarning:\s*\{\}?$/.test(notice.message)) { return false }

  // Google Maps
  if (/maps\.googleapis\.com/.test(notice.stack)) { return false }
  if (/b\.getBoundingClientRect/.test(notice.message)) { return false }
  if (/The Google Maps JavaScript API could not load/.test(notice.message)) { return false }

  // Accessibe
  if (/acsbapp\.com/.test(notice.stack)) { return false }
  if (/acsbJS is not defined/.test(notice.message)) { return false }
  if (/Can't find variable: acsbJS/.test(notice.message)) { return false }

  try { notice.context.signedIn ??= isSignedIn() } catch { /* no-op */ }
  try { notice.context.userId ??= currentUserId() } catch { /* no-op */ }
})

// See documentation for a list of options:
// https://docs.honeybadger.io/lib/javascript/guides/reporting-errors/#additional-options
export default function reportException(error, options) {
  Honeybadger.notify(error, options)
};

Honeybadger.addBreadcrumb("Page loaded", {
  category: "navigation",
  metadata: window.location,
})
